export default function getScrollFrame() {
  return document.querySelector('.app-body > main.main');
}
